import {
  GET_TRANSACTION_LIST_REQUEST,
  GET_TRANSACTION_LIST_SUCCESS,
  GET_TRANSACTION_LIST_FAILURE
} from '../constants/transactionConstants';

const initialState = {
  loading: false,
  transactions: [],
  totalCount: 0,
  error: null
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.response || [],
        totalCount: action.payload.pagination?.totalItems || 0
      };

    case GET_TRANSACTION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default transactionReducer;